import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../view/main/home";
import MainLayout from "../components/layout/main.layout";
import Login from "../view/auth/login";
import BackupUser from "../view/contents/backup/backup.user";
import Layout from "../components/layout/layout";
import UserList from "../view/contents/user/user.list";
import PrivateRoute from "./private.router";
import BackupDeviceList from "../view/contents/backup/backup.device.list";
import BackupFileList from "../view/contents/backup/backup.file.list";
import BackupFolderList from "../view/contents/backup/backup.folder.list";
import DownloadFileList from "../view/contents/download/download.list";
import Join from "../view/auth/join";
import NotFound from "../view/error/error.404";
import BackupHistory from "../view/contents/history/backup.history";
import DbFileList from "../view/contents/db/db.file.list";
import DbUser from "../view/contents/db/db.user";
import DbDeviceList from "../view/contents/db/db.device.list";
import ImageUser from "../view/contents/image/image.user";
import ImageDevice from "../view/contents/image/image.device";
import ImageDrive from "../view/contents/image/image.drive";
import ImageContents from "../view/contents/image/image.contents";
import BackupDateSelect from "../view/contents/backup/backup.date.select";
import WormList from "../view/contents/worm/worm.list";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route index path="/join" element={<Join />} />
        </Route>

        <Route path="/login" index element={<Login />} />

        {/* ✅ 로그인 필요 라우트 */}
        <Route element={<PrivateRoute />}>
          <Route element={<Layout />}>
            {/* backup */}
            <Route path="/backup/user" index element={<BackupUser />} />
            <Route
              path="/backup/device/:id"
              index
              element={<BackupDeviceList />}
            />
            <Route
              path="/backup/folder/:deviceId"
              index
              element={<BackupFolderList />}
            />
            <Route
              path="/backup/file/list/:path/*"
              index
              element={<BackupFileList />}
            />
            <Route
              path="/backup/date/select/:path/*"
              index
              element={<BackupDateSelect />}
            />

            <Route path="/db/user" index element={<DbUser />} />
            <Route path="/db/device/:id" index element={<DbDeviceList />} />
            <Route path="/db/file/:path/*" index element={<DbFileList />} />

            <Route path="/image/user" index element={<ImageUser />} />
            <Route path="/image/device/:id" index element={<ImageDevice />} />
            <Route path="/image/drive/:path/*" index element={<ImageDrive />} />
            <Route path="/image/contents" index element={<ImageContents />} />
            <Route
              path="/image/contents/:path/*"
              index
              element={<ImageContents />}
            />

            {/* user list */}
            <Route path="/user/list" index element={<UserList />} />

            <Route path="/worm/list" index element={<WormList />} />

            {/* download */}
            <Route path="/download/list" index element={<DownloadFileList />} />

            <Route path="/history/list" index element={<BackupHistory />} />
          </Route>
        </Route>

        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
